export const ruRU = {
  ANSWER: {
    CARRIER: {
      "3PL": "3PL",
      BREAD: "BREAD",
      COKE: "COKE",
      DSD: "DSD",
      FLOWERS: "FLOWERS",
      GFS: "GFS",
      LCL: "LCL",
      MEAT: "MEAT",
      PEPSI: "PEPSI",
    },
    DRIVER_TYPE: {
      CONTRACTOR: "Подрядчик",
      DELIVERY: "Доставка",
      FLEET_DRIVER: "Водитель автопарка",
      GULFSTREAM: "Gulfstream",
      MAINTENANCE: "Техническое обслуживание",
      PERSONAL_VEHICLE: "Личное авто",
      SERVICE: "Обслуживание",
      SHUNT_DRIVER: "Водитель маневрового транспорта",
      SHUTTLE_DRIVER: "Водитель маршрутного транспорта",
    },
    DUNNAGE: {
      "1_2": "1/2",
      "1_4": "1/4",
      FULL: "Полный",
    },
    ENTRY_PURPOSE: {
      BOBTAIL: "Тягач без прицепа",
      CARRIER_LOADED: "Перевозчик с грузом",
      CONTRACTOR: "Подрядчик",
      CONTRACTOR_VISITOR: "Подрядчик/посетитель",
      DELIVERY: "Доставка",
      DROP: "Сброс",
      DROP_HOOK: "Сброс и зацепка",
      EMPTY: "Пустой",
      EMPTY_TRAILER: "Пустой прицеп",
      FOODBANK: "Банк продовольствия",
      FUEL: "Топливо",
      LIVE_LOAD: "Прямая погрузка",
      LOADED: "Загруженный",
      NFI_LOADED: "Загруженный непродовольственными товарами",
      OTHERS: "Другое",
      PARKING: "Стоянка",
      PICKUP_EMPTY: "Подбор пустого",
      PICKUP_LOAD: "Подбор груза",
      PICK_UP: "Подбор",
      PLANT_LOADED: "Загруженный на заводе",
      PRIVATE: "Частный",
      REPAIR: "Ремонт",
      VISITOR: "Посетитель",
      WAAS_FAAS: "WAAS/FAAS",
      WASH: "Мойка",
    },
    ENTRY_TYPE: {
      INBOUND: "Входящий",
      INBOUND_ARRIVAL: "Входящий/\nприбытие",
      INBOUND_DROP: "Входящий/сброс",
      MAINTENANCE: "Техническое обслуживание",
      OUTBOUND: "Исходящий",
      OUTBOUND_DEPARTURE: "Исходящий/\nотправление",
      OUTBOUND_PICKUP: "Исходящий/подбор",
      WALMART_CARRIERS: "Перевозчики Walmart",
      YARD_STORAGE: "Хранение на участке",
    },
    EQUIPMENT_LENGTH: {
      "20": "20",
      "40": "40",
      "48": "48",
      "53": "53",
    },
    EQUIPMENT_TYPE: {
      BOBTAIL: "Тягач без прицепа",
      CHASSIS: "Шасси",
      CONTAINER: "Контейнер",
      TRAILER: "Прицеп",
      VAN: "Фургон",
    },
    FUEL_LEVEL: {
      "1_2": "1/2",
      "1_4": "1/4",
      "1_8": "1/8",
      "3_4": "3/4",
      "3_8": "3/8",
      "5_8": "5/8",
      "7_8": "7/8",
      EMPTY: "Пустой",
      FULL: "Полный",
    },
    GENERIC: {
      NO: "НЕТ",
      YES: "ДА",
    },
    LOADED_STATUS: {
      EMPTY: "Пустой",
      LOADED: "Загруженный",
    },
    LOAD_DETAILS: {
      CONVERTER_1X: "CONVERTER_1X",
      CONVERTER_2X: "CONVERTER_2X",
      DRY: "СУХОЙ",
      FROZEN: "ЗАМОРОЖЕННЫЙ",
      HEAT: "ПОДОГРЕВ",
      "MULTI TEMP": "МУЛЬТИТЕМПЕРАТУРНЫЙ",
      REEFER: "РЕФРИЖЕРАТОР",
    },
    LOAD_TYPE: {
      BOBTAIL: "Тягач без прицепа",
      EMPTY: "Пустой",
      LOADED: "Загруженный",
      OTHERS: "Другое",
    },
    REEFER: {
      OFF: "Выкл.",
      ON: "Вкл.",
    },
    TRAILER_TYPE: {
      DRY: "Сухой",
      REEFER: "Рефрижератор",
    },
    VISIT_TYPE: {
      DROP_AND_GO: "Сброс и отправление",
      DROP_AND_WAIT: "Сброс и ожидание",
      DROP_EMPTY: "Сброс пустого",
      PICKUP_EMPTY: "Подбор пустого",
    },
  },
  APP: {
    DEVELOPED_BY_EAIGLE: "Разработано EAIGLE",
    INVALID_FACILITY: "ОБЪЕКТ НЕ НАЙДЕН.",
    PAGE_NOT_FOUND: "Страница не найдена. Недействительные параметры",
    PLEASE_ROTATE: "Чтобы использовать приложение, поверните устройство вертикально.",
    POWERED_BY_EAIGLE: "Предоставлено <LOGO/> eaigle.com",
  },
  AVAC: {
    ADD_COMMENT_HEADER: "Добавить комментарий (обязательно)",
    AREA: {
      ISO: "ISO",
      TANK_WASH: "Мойка резервуара",
    },
    COMMENT_HERE: "Добавьте свой комментарий здесь…",
    COMMENT_SUBMITTED: "Комментарий отправлен",
    DETAILS: {
      ACTUAL_TEMPERATURE: "Фактическая температура",
      ADDITIONAL_COMMENTS: "Дополнительные комментарии",
      ALLOCATED_PAD: "Выделенная ПЛОЩАДКА",
      APPOINTMENT_INFORMATION: "Информация о назначении",
      APPOINTMENT_NUMBER: "Номер назначения",
      APPOINTMENT_TIME: "Время назначения",
      APPOINTMENT_TYPE: "Тип назначения",
      AVAC_EVENT: "Мероприятие AVAC",
      BOL_NUMBER: "Номер коносамента",
      BOOKING_NUMBER: "Номер бронирования",
      BRE_STATUS: "Статус BRE",
      BROKER: "Брокер",
      CARRIER: "Перевозчик",
      CARRIER_NAME: "Наименование перевозчика",
      CHASSIS_NUMBER: "Номер шасси",
      CHILD_SCAC: "Дочерний SCAC",
      COMMENT: "Комментарий",
      CVIP_DATE: "Дата CVIP",
      CV_DETAILS: "Сведения CV",
      CV_EVENT_ID: "Идентификатор события CV",
      DELIVERY_NOTE: "Примечание о доставке",
      DESCRIPTION: "Описание",
      DRIVER_ENGAGEMENT_TIME: "Время реагирования водителя (сек.)",
      DRIVER_INFORMATION: "Информация о водителе",
      DRIVER_NAME: "Имя водителя",
      DUNNAGE: "Деннаж",
      ENTRY_SUBTYPE: "Подтип въезда",
      ENTRY_TYPE: "Тип въезда",
      EQUIPMENT_LENGTH: "Длина оборудования",
      EQUIPMENT_LOADED_STATUS: "Состояние загруженности оборудования",
      EQUIPMENT_TYPE: "Тип оборудования",
      EQUIPMENT_TYPE_ID: "Идентификатор типа оборудования",
      EVENT_ID: "Идентификатор события",
      EVENT_INFORMATION: "Информация о событии",
      EVENT_TIME: "Время события",
      EVENT_TYPE: "Тип события",
      FAILURE_REASON: "Причина сбоя",
      FIRST_NAME: "Имя",
      FUEL_LEVEL: "Уровень топлива",
      GATE_ENGAGEMENT_TIME: "Время реагирования ворот (сек.)",
      ID: "Идентификатор",
      IMAGES: "Изображения",
      LANE_ID: "Идентификатор полосы",
      LANE_NAME: "Наименование полосы",
      LAST_NAME: "Фамилия",
      LIVE_DROP: "Немедленный сброс",
      LOAD_ID: "Идентификатор груза",
      LTL: "LTL",
      MC_NUMBER: "Номер автотранспортной компании",
      OPERATOR_COMMENTS: "Комментарии оператора",
      ORDER_NUMBER: "Номер заказа",
      PARENT_SCAC: "Родительский SCAC",
      PHONE_NUMBER: "Номер телефона",
      PLATE_NUMBER: "Номерной знак",
      PO: "Заказ",
      PO_LOAD_DETAILS: "Заказ / сведения о грузе",
      PO_NUMBER: "Номер заказа",
      RAIL_CARS: "Железнодорожные вагоны",
      REFERENCE_NUMBER: "Справочный номер",
      SCAC: "SCAC",
      SEAL_NUMBER: "Номер пломбы",
      SET_TEMPERATURE: "Установленная температура",
      SPOT_NUMBER: "Номер точки",
      START_TIME: "Время начала",
      STATUS: "Статус",
      TEMPERATURE: "Температура",
      TIMESTAMP: "Временная метка",
      TRACTOR_ID: "Идентификатор тягача",
      TRACTOR_NUMBER: "Номер тягача",
      TRAILER: "Прицеп",
      TRAILER_NUMBER: "Номер прицепа",
      TRAILER_TYPE: "Тип прицепа",
      TRUCK_INFORMATION: "Информация о грузовике",
      TRUCK_NUMBER: "Номер грузовика",
      UNIT: "Элемент",
      UNIT_ID: "Идентификатор элемента",
      UNIT_NUMBER: "Номер элемента",
      UNIT_TYPE: "Тип элемента",
      USDOT_NUMBER: "Номер USDOT",
      VEHICLE_MEDIA: "Мультимедийная система автомобиля",
      VIDEOS: "Видео",
      WAC: "Код склада",
      ZONE: "Зона",
    },
    DRIVER_ASSIST: "Помощь водителю",
    DRIVER_CREATED: "Водитель создан.",
    DRIVER_PIN: "PIN-код водителя:",
    DRIVER_QR_CODE: "QR-код водителя",
    DRIVER_UPDATED: "Водитель обновлен.",
    ERROR: {
      ACCESS_DENIED: "Доступ запрещен",
      ACCESS_DENIED_DETAILS: "У вас нет доступа к этому модулю.",
      AUTH_ERROR: "Ошибка аутентификации: {{ERROR}}",
      CONTACT_ADMIN: "Обратитесь к администратору за разрешением.",
      ERROR_CREATING_DRIVER: "Возникла ошибка при создании водителя",
      ERROR_UPDATING_DRIVER: "Возникла ошибка при обновлении водителя",
      FAILED_TO_CREATE_DRIVER: "Не удалось создать водителя",
      FAILED_TO_FETCH_FACILITIES: "Не удалось найти объекты",
      FAILED_TO_UPDATE_DRIVER: "Не удалось обновить водителя",
      LOADING_EVENT_DETAILS_AVAC:
        "Ошибка загрузки сведений о событии. Перенаправление в AVAC…",
      LOADING_EVENT_DETAILS_GATE_LOG:
        "Ошибка загрузки сведений о событии. Перенаправление в журнал ворот…",
      MISSING_EMAIL_AND_PHONE_NUMBER:
        "Укажите адрес электронной почты или номер телефона",
      NO_FACILITY_SELECTED: "Объект не выбран",
      WEBSOCKET_ERROR: "Ошибка WebSocket: {{ERROR}}",
    },
    FACILITY: "Объект",
    FAILED_EVENTS: "События с ошибками",
    HISTORICAL_EVENTS: "История событий (за последний день)",
    IMAGE_MODAL_INSTRUCTIONS:
      "Прокрутите для увеличения • Перетащите для панорамирования при увеличении",
    NEW_DRIVER: {
      PIN_SENT: "PIN-код отправлен на электронную почту и номер телефона водителя.",
      QR_CODE_AND_PIN_SENT:
        "QR-код и PIN-код отправлены на электронную почту и номер телефона водителя.",
      QR_CODE_SENT: "QR-код отправлен на электронную почту и номер телефона водителя.",
    },
    NO_APPROVED_EVENTS: "В выбранном диапазоне дат не найдено одобренных событий",
    NO_EVENTS: "Нет доступных событий",
    NO_FAILED_EVENTS: "Не найдено событий с ошибками в последний день",
    NO_INVENTORY: "Инвентарные объекты не найдены.",
    NO_LANES: "Полосы не найдены.",
    NO_MATCHES: "Совпадения не найдены",
    NO_NON_FAILURE_EVENTS: "Не найдено событий без ошибок в последний день",
    NO_VEHICLE_MEDIA: "Мультимедийные системы автомобиля недоступны",
    PRODUCT_NAME: "AVAC™",
    READ_AND_AGREE: "Прочтите и согласитесь с <BUTTON>формой отказа</BUTTON>",
    SELECT_LANE: "Выберите полосу",
    SUBMITTING: "Отправка…",
    SUGGESTION: {
      EMAIL_OR_PHONE_NUMBER: "Укажите электронную почту или номер телефона",
    },
    TOAST: {
      APPROVE_EVENT_FAILED: "Не удалось одобрить событие. Повторите попытку.",
      EVENT_APPROVED: "Событие одобрено. Нажмите кнопку «Открыть ворота».",
      EVENT_REJECTED: "Событие отклонено.",
      GATE_OPENED: "Ворота открыты.",
      OPEN_GATE_FAILED:
        "Не удалось открыть ворота. Повторите попытку или обратитесь в службу поддержки.",
      REJECT_EVENT_FAILED: "Не удалось отклонить событие. Повторите попытку.",
    },
    VALIDATING_ACCESS: "Проверка доступа…",
    VALIDATION: {
      INVALID_EMAIL: "Введите действительный адрес электронной почты",
      INVALID_NAME: "Поддерживаются только буквы и пробелы",
      INVALID_PHONE_NUMBER: "Введите действительный 10-значный номер телефона",
    },
  },
  BRE: {
    FAILED_TO_OPEN_GATE: "Не удалось открыть ворота",
    GATE_OPEN_FAILED: "Ошибка открытия ворот",
    INVALID_APPOINTMENT: "Недействительное назначение",
    DRIVER_REGISTRATION_EXPIRED:
      "Регистрация водителя недействительна. Обратитесь к оператору ворот.",
    INVALID_QRCODE_FORMAT: "Недействительный формат QR-кода",
    KRAFT: {
      APPOINTMENT_USAGE_EXCEEDED: "Превышен лимит использования назначения",
      BOL_CALL_FAILED: "Ошибка вызова коносамента",
      BOL_CALL_FAILED_NO_LANE_EVENT:
        "Ошибка вызова коносамента, или не найдено InProgress CVLaneEvent",
      BOL_PO_MISSING: "В назначении отсутствует номер коносамента/заказа",
      BOL_PO_MISSING_NO_LANE_EVENT:
        "В назначении отсутствует номер коносамента/заказа, а InProgress CVLaneEvent не найдено",
      CVLANE_EVENT_NOT_FOUND: "CVLaneEvent не существует",
      EVENT_OUTSIDE_OPERATION_HOURS: "Событие вне рабочих часов",
      FAILED_OBTAIN_BOL_INFO: "Не удалось получить информацию коносамента",
      FUEL_LEVEL_BELOW_THRESHOLD:
        "Уровень топлива ниже 0,75, и не найдено InProgress CVLaneEvent",
      FUEL_LEVEL_BELOW_THRESHOLD_NO_LANE_EVENT:
        "Уровень топлива ниже 0,75, и не найдено InProgress CVLaneEvent",
      INTERNAL_FAILURE: "Внутренний сбой",
      INVALID_APPOINTMENT_ENTRY_SUBTYPE: "Недействительный подтип въезда в назначении",
      INVALID_APPOINTMENT_ENTRY_TYPE: "Недействительный тип въезда в назначении",
      INVALID_APPOINTMENT_QR_CODE: "Недействительный QR-код в назначении",
      INVALID_ENTRY_SUBTYPE: "Недействительный подтип въезда",
      INVALID_ENTRY_SUBTYPE_IN_APPOINTMENT: "Недействительный подтип въезда в назначении",
      INVALID_ENTRY_SUBTYPE_NO_LANE_EVENT:
        "Недействительный подтип въезда в назначении, и не найдено InProgress CVLaneEvent",
      INVALID_INBOUND_BOBTAIL_PLATE_NUMBER:
        "Недействительный номерной знак входящего тягача без прицепа",
      INVALID_OUTBOUND_EMPTY_APPOINTMENT_USAGE:
        "Недействительное использование назначения для исходящего пустого",
      INVALID_QRCODE_SOURCE: "Недействительный источник QR-кода",
      MAX_APPOINTMENT_LIMIT_REACHED:
        "Достигнут максимальный лимит использования назначения",
      NO_CV_LANE_EVENT_FOUND_OR_UNSUPPORTED_APPOINTMENT_MISMATCH_USAGE:
        "CV LaneEvent не найдены, или неподдерживаемое использование назначения",
      NO_INPROGRESS_LANE_EVENT_FOUND: "InProgress LaneEvent не найдены",
      NO_INPROGRESS_LANE_EVENT_FOUND_OR_TRAILER_NUMBER_IS_PRESENT_IN_THE_RECORD:
        "InProgress LaneEvent не найдены, или в записи присутствует номер прицепа",
      NO_USER_INFO_RECEIVED: "Не получена информация о пользователе",
      NO_VEHICLE_DETECTED: "Автомобиль не обнаружен, или тип автомобиля недействителен",
      NO_VEHICLE_DETECTED_BOBTAIL:
        "Автомобиль не обнаружен, или это не тягач без прицепа",
      PLEASE_PROCEED_TO_DOCK_OFFICE: "Проследуйте в офис дока",
      SEAL_NUMBER_MISMATCH: "Номер пломбы не совпадает",
      SEAL_NUMBER_MISSING: "Номер пломбы отсутствует для записи об исходящем загруженном",
      TEMPERATURE_EXCEEDS_LIMIT: "Температура превышает предел",
      TEMPERATURE_INFO_MISSING:
        "Нет информации о температуре, и проверку температуры нельзя пропустить из-за текущего сезона",
      TEMPERATURE_INFO_MISSING_NO_LANE_EVENT:
        "Нет информации о температуре, и проверку температуры нельзя пропустить из-за текущего сезона. InProgress CVLaneEvent не найдено",
      TEMPERATURE_INFO_NOT_INCLUDED: "В назначение не включена информация о температуре",
      TEMPERATURE_INFO_NOT_INCLUDED_NO_LANE_EVENT:
        "В назначение не включена информация о температуре, а InProgress CVLaneEvent не найдено",
      TRAILER_NUMBER_DOES_NOT_MATCH: "Номер прицепа не совпадает.",
      TRAILER_NUMBER_DOES_NOT_MATCH_WITH_RECORD: "Номер прицепа не совпадает с записью",
      TRAILER_NUMBER_IS_NOT_AVAILABLE: "Номер прицепа недоступен",
      TRAILER_NUMBER_MISSING: "Номер прицепа отсутствует или не совпадает с записью",
      TRAILER_NUMBER_NOT_PRESENT: "В назначении нет номера прицепа",
      TRAILER_NUMBER_SHOULD_NOT_EXIST: "В записи не должно быть номера прицепа",
      UNABLE_TO_VALIDATE_TEMPERATURE: "Не удалось подтвердить температуру",
      UNSUPPORTED_APPOINTMENT_TYPE: "Неподдерживаемый тип назначения",
    },
    LACTALIS: {
      APPOINTMENT_DOES_NOT_EXIST: "Назначение отсутствует",
      OFF_HOURS_OUTBOUND_TRAILER:
        "Для исходящих с прицепом в нерабочее время необходимо использовать внутреннюю связь",
      OUTBOUND_TRAFFIC_WORKING_HOURS:
        "Для исходящего трафика в рабочее время необходимо использовать внутреннюю связь",
      YMS_CHECKIN_FAILED: "Ошибка регистрации въезда YMS. Свяжитесь с оператором ворот",
    },
    LOBLAW: {
      ENTRY_APPROVED: "Въезд одобрен. Проследуйте на площадку {{MESSAGE}}",
      INVALID_INFORMATION: "Недействительная информация",
      PROCEED_TO_DISPATCH:
        "{{MESSAGE}} Обратитесь в диспетчерскую за подробной информацией",
      SEE_YOU_NEXT_TIME: "{{MESSAGE}} До встречи!",
    },
    PORTCITY: {
      AFTER_HOURS_ENTRY:
        "Для въезда в нерабочее время используйте цифровую клавиатуру на центральной полосе. Код от диспетчерской службы",
      BOOKING_NUMBER_PROVIDED_NOT_VALID: "Указанный номер бронирования недействителен",
      INVALID_EAIGLE_APPOINTMENT_RECORD: "Недействительная запись о назначении в Eaigle",
      INVALID_PROFILE_OR_EXPIRED_CREDENTIAL:
        "Недействительный профиль или просроченное удостоверение",
      IT_IS_NOT_AN_OUTBOUND_BOBTAIL: "Это не исходящий тягач без прицепа",
      IT_IS_NOT_A_BOBTAIL: "Это не тягач без прицепа",
      LOADID_PROVIDED_IS_NOT_VALID: "Указанный идентификатор груза недействителен",
      NO_BOOKING_NUMBER_PROVIDED: "Номер бронирования не указан",
      NO_INPROGRESS_CV_LANE_EVENT_FOUND: "InProgress CV LaneEvent не найдены",
      NO_LOADID_PROVIDED: "Идентификатор груза не указан",
      PICK_UP_BOL: "{{MESSAGE}} Подберите коносамент у ворот 25",
      PLEASE_CONTACT_SECURITY_TO_OPEN_GATE: "Свяжитесь с охраной, чтобы открыть ворота",
      UNSUPPORTED_APPOINTMENT_TYPE: "Неподдерживаемый тип назначения",
      UNSUPPORTED_OPERATION_TYPE: "Неподдерживаемый тип операции",
    },
    TRIMAC: {
      NOT_A_VALID_REQUEST: "Недействительный запрос",
    },
  },
  CARRIER: {
    SCAC_AND_NAME: "{{SCAC}} ({{NAME}})",
    NAME_AND_SCAC: "{{NAME}} ({{SCAC}})",
  },
  CATEGORY: {
    ACTUAL_TEMPERATURE: "Фактическая температура",
    ACTUAL_TEMPERATURE_F: "Фактическая температура в °F",
    COMPANY: "Информация о компании",
    EQUIPMENT_DETAILS: "Сведения об оборудовании",
    LOAD_DETAILS: "Сведения о грузе",
    PERSONAL: "Личная информация",
    PURPOSE_DETAILS: "Сведения о цели",
    SAFETY: "Безопасность",
    SET_TEMPERATURE: "Установленная температура",
    SET_TEMPERATURE_F: "Установленная температура в °F",
    SHIPPING_DETAILS: "Сведения об отправке",
    SHIPPING_DETAILS_WITHOUT_VALIDATION: "Сведения об отправке без проверки",
    SHIPPING_DETAILS_WITH_VALIDATION: "Сведения об отправке с проверкой",
    VEHICLE_EQUIPMENT_DETAILS: "Сведения об автомобиле/оборудовании",
    VISIT_PURPOSE: "Цель визита",
  },
  COMMAND: {
    ADD_NEW_DRIVER: "Добавить нового водителя",
    APPROVE: "Одобрить",
    BACK: "Назад",
    BACK_TO_EVENTS: "Назад к событиям",
    CHECK_IN: "Регистрация въезда",
    CHECK_OUT: "Регистрация отъезда",
    CLEAR: "Очистить",
    CLICK_TO_EDIT: "Нажмите для редактирования",
    CLOSE: "Закрыть",
    CLOSE_IMAGE_MODAL: "Закрыть окно изображения",
    DELETE: "Удалить",
    EDIT: "Редактировать",
    LOGOUT: "Выход",
    NEXT: "Далее",
    OPEN_GATE: "Открыть ворота",
    REJECT: "Отклонить",
    RETURN: "Назад",
    SELECT_END: "Выберите конец",
    SELECT_START: "Выберите начало",
    SSO_LOGIN: "Вход с помощью Azure AD",
    START_NEW_REGISTRATION: "Начать новую регистрацию",
    SUBMIT: "Отправить",
    TODAY: "Сегодня",
    UPDATE: "Обновить",
  },
  DAY: {
    "0": "Вс.",
    "1": "Пн.",
    "2": "Вт.",
    "3": "Ср.",
    "4": "Чт.",
    "5": "Пт.",
    "6": "Сб.",
  },
  ERROR: {
    VIDEO_NOT_SUPPORTED: "Ваш браузер не поддерживает тег видео.",
  },
  ERROR_MODAL: {
    INVALID_X: "Недействительный {{TITLE}}",
  },
  EVENT_STATUS: {
    APPROVED: "одобрено",
    FAILURE: "ошибка",
    INPROGRESS: "активно",
    REJECTED: "отклонено",
    SUCCESS: "выполнено",
  },
  FAILURE_PAGE: {
    BODY: "Нажмите кнопку внутренней связи на стойке",
    FAILURE: "Ошибка",
    HEADER: "Информация не проверена.",
    INTERCOM: "Внутренняя связь",
  },
  FILTER: {
    CARD: {
      EVENT_TYPE: "Тип события",
      STATUS: "Статус",
      TIME: "Время",
      TRAILER_LOGO: "Логотип прицепа",
    },
    EVENT_TYPE: {
      JB_HUNT: "JB Hunt",
    },
    LOGO: {
      AB: "AB",
      CD: "CD",
      DH: "DH",
      EF: "EF",
    },
    STATUS: {
      CLEAN: "Чистый",
      DIRTY: "Грязный",
      EMPTY: "Пустой",
      INBOUND: "Входящий",
      LOADED: "Загруженный",
      OUTBOUND: "Исходящий",
    },
    TIME: {
      LAST_24_HOURS: "П. 24 ч",
      LAST_MONTH: "П. месяц",
      LAST_WEEK: "П. неделя",
      LAST_YEAR: "П. год",
      TODAY: "Сегодня",
    },
  },
  FORM_INPUT: {
    COMMAND: {
      ENTER_SCAC: "Нажмите, чтобы ввести SCAC вручную",
      SELECT_SCAC: "Нажмите, чтобы выбрать один из доступных кодов SCAC",
      SHOW_LESS: "Показать меньше",
      SHOW_MORE: "Показать больше",
    },
    FIELD_IS_REQUIRED: "Это поле обязательно для заполнения",
    NO_MATCHES: "Совпадения не найдены",
    REQUIRED_LABEL: "{{TEXT}}*",
    SELECT: "Найдите или выберите…",
    SELECT_CARRIER: "Найдите или выберите перевозчика…",
    SELECT_DATE: "Выберите дату",
    SELECT_OPTIONS: "Выберите параметры…",
    TRUNCATED: "{{TEXT}}…",
  },
  FORM_PAGE: {
    COMMAND: {
      NEXT: "Далее",
      SUBMIT: "Отправить",
    },
    ERROR: {
      UNABLE_TO_SUBMIT: "Не удалось отправить форму. Повторите попытку позже.",
    },
    VALIDATING: "Проверка…",
  },
  HINT: {
    EDIT_SEAL_NUMBER: "* При необходимости отредактируйте отображаемый номер пломбы.",
    LOAD_ID_8_DIGITS: "Идентификатор груза — это 8-значный номер, начинающийся с 4",
    SCAC_NOT_LISTED_CPU9: "Если в списке нет вашего кода SCAC, введите CPU9.",
  },
  IDCAPTURE: {
    CAMERA_ERROR: {
      BODY: "Не удалось получить доступ к вашей камере. Проверьте разрешения и повторите попытку.",
      HEADER: "Ошибка доступа к камере",
    },
    COMMAND: {
      CAPTURE: "Идентификатор съемки",
      CAPTURING: "Съемка…",
      CHANGE_TYPE: "Изменить тип идентификатора",
      DONE: "Готово",
      RETAKE_PHOTOS: "Переснять фото",
      SUBMIT: "Отправить",
      SWITCH_CAMERA: "Переключить камеру",
      TRY_AGAIN: "Повторить попытку",
      TRY_BACK: "Попробовать заднюю камеру",
      TRY_FRONT: "Попробовать переднюю камеру",
    },
    EMPLOYEE_ID_BACK: "Удостоверение сотрудника (тыльная сторона)",
    EMPLOYEE_ID_BACK_ALT: "Тыльная сторона удостоверения сотрудника",
    EMPLOYEE_ID_FRONT: "Удостоверение сотрудника (лицевая сторона)",
    EMPLOYEE_ID_FRONT_ALT: "Лицевая сторона удостоверения сотрудника",
    ERROR: {
      EXPIRED:
        "Срок действия удостоверения истек. Предоставьте действительное удостоверение личности.",
      GENERIC: "Возникла ошибка",
      NO_CAMERA:
        "Нет доступной камеры. Подключите камеру или попробуйте использовать другой браузер.",
      NO_SWITCH:
        "Невозможно переключить камеру, поскольку доступно только одно видеоустройство.",
      PERMISSION_DENIED:
        "Отказано в разрешении. Обновите браузер и дайте разрешение на использование камеры.",
      UNREADABLE: "Не удалось прочитать информацию с удостоверения.",
      UNSUPPORTED: "Холст не поддерживается.",
      UPLOAD_FAILED: "Не удалось загрузить изображения удостоверения сотрудника",
      UPLOAD_FAILED_TRY_AGAIN:
        "Не удалось загрузить изображения удостоверения сотрудника. Повторите попытку.",
      VERIFY_FAILED_TRY_AGAIN: "Ошибка проверки удостоверения. Повторите попытку.",
    },
    ID_INFORMATION: "Информация об удостоверении",
    ID_NOT_VERIFIED_MESSAGE:
      "Мы не смогли полностью проверить ваше удостоверение. Проверьте сведения ниже.",
    ID_NOT_VERIFIED_STATUS: "Проблемы с проверкой удостоверения",
    ID_VERIFIED_MESSAGE: "Ваше удостоверение успешно проверено.",
    ID_VERIFIED_STATUS: "Удостоверение успешно проверено",
    INSTRUCTIONS: {
      DRIVERS_LICENSE:
        "Поместите водительские права в рамку и обеспечьте хорошее освещение.",
      EMPLOYEE_ID_BACK:
        "Теперь поместите ТЫЛЬНУЮ сторону удостоверения сотрудника в рамку.",
      EMPLOYEE_ID_FRONT: "Поместите ЛИЦЕВУЮ сторону удостоверения сотрудника в рамку.",
    },
    PROCESSING: "Обработка…",
    SELECT_TYPE: "Выберите тип удостоверения",
    TYPE: {
      DRIVERS_LICENSE: "Водительские права",
      EMPLOYEE_ID: "Удостоверение сотрудника",
    },
  },
  IMAGE_PREVIEW: {
    CAPTURED_ID: "Снятое удостоверение",
    COMMAND: {
      RETAKE: "Переснять",
      SUBMIT: "Отправить",
    },
    PLEASE_WAIT: "Подождите, пока мы проверим вашу информацию",
    PROCESSING_ID: "Обработка вашего удостоверения…",
    SUBMITTING: "Отправка…",
    TIP: "Убедитесь, что изображение четкое и хорошо читается.",
  },
  KIOSK: {
    COMMAND: {
      ENTER: "Ввести",
      REGISTER_NOW: "Зарегистрироваться сейчас",
    },
    ERROR: {
      CONNECTION_CLOSED: "Соединение закрыто",
      CONNECTION_ERROR: "Ошибка соединения",
      ENTRY_TYPE_INVALID: "Тип въезда «{{TYPE}}» недействителен",
      ENTRY_TYPE_MISSING: "Тип въезда отсутствует",
      FAILED_TO_CONNECT: "Не удалось установить соединение",
      INFORMATION_NOT_VERIFIED_USE_INTERCOM:
        "Информация не проверена. Использовать внутреннюю связь",
      INTERACTION_TYPE_INVALID: "Тип взаимодействия «{{TYPE}}» недействителен",
      INTERACTION_TYPE_MISSING: "Тип взаимодействия отсутствует",
      INTERMITTENT_CONNECTION:
        "Нестабильное соединение\nЕсли проблема не решится, обратитесь в службу поддержки EAIGLE по номеру 1 888 771 1584",
      INTERMITTENT_CONNECTION_N:
        "Нестабильное соединение {{N}}; Если проблема не решится, обратитесь в службу поддержки EAIGLE по номеру 1 888 771 1584",
      MISSING_REQUIRED_INFO: "Отсутствует необходимая информация",
      PROCESSING_ERROR: "Ошибка обработки вашего запроса. Использовать внутреннюю связь",
      VALIDATION_FAILED: "Ошибка проверки",
      VALIDATION_TIMEOUT: "Время проверки истекло",
    },
    FOOTER: {
      NOT_REGISTERED: "Не зарегистрированы?",
    },
    GATE_OPEN: "Ворота открыты",
    INFORMATION_VERIFIED: "Информация проверена.",
    INVALID_URL_PARAMETERS: "Недействительные параметры URL",
    KEY: {
      BACKSPACE: "Возврат",
      CLEAR: "Очистить",
      CLOSE: "Закрыть",
    },
    KEY_PAD_INSTRUCTIONS: "Введите OTP",
    PLEASE_ROTATE_LANDSCAPE: "Поверните устройство горизонтально",
    PLEASE_WAIT_X: "Пожалуйста, подождите. {{TEXT}}",
    PRE_REGISTERED: "Уже зарегистрированы?",
    PROCEED_TO_EXIT: "Проследуйте к выходу",
    PROCEED_TO_ZONE: "Проследуйте в назначенную зону",
    REDIRECTING: "Перенаправление…",
    SCAN_QR_CODE:
      "Поднесите зарегистрированный <br/>QR-код к стойке<br/> для сканирования.",
    SECONDS_REMAINING: "Осталось {{N}} сек.",
    TROUBLE_SCANNING_QR_CODE:
      "Ошибка сканирования QR-кода: нажмите здесь, чтобы ввести код назначения вручную",
    VALIDATION: {
      PERSON_NAME: "Только буквы и пробелы",
      PHONE_NUMBER: "например, 1234567890",
    },
    VERIFYING_INFORMATION: "Проверка информации…",
    VIDEO_NOT_AVAILABLE: "Видео в реальном времени недоступно",
    WAIT_VERIFY_INFO: "Подождите, пока мы проверим вашу информацию",
    WAIT_VERIFY_QR: "Подождите, пока будет проверен QR-код",
  },
  LABEL: {
    APPROVED: "Одобрено",
    AREA: "Область",
    CARRIER: "Перевозчик",
    CHECK_ICON: "Значок проверки",
    CHECK_IN_TIME: "Время регистрации въезда",
    CHECK_OUT_TIME: "Время регистрации отъезда",
    DETENTION_TIME: "Время задержки",
    INDICATORS: "Индикаторы",
    DETENTION_TIME_HOURS: "Время задержки (в часах)",
    DRIVERS: "Водители",
    DURATION: "Продолжительность",
    ERROR_ICON: "Значок ошибки",
    FIRST_NAME_LAST_NAME: "{{FIRST}} {{LAST}}",
    FROM_DATE_TIME_TZ: "От: {{DATE_TIME_TZ}}",
    GATE_LOG: "Журнал ворот",
    GATE_OPEN: "Ворота открыты",
    LOCATION: "Расположение",
    NOT_APPLICABLE: "Н/Д",
    OPENING: "Открытие…",
    REGISTRATION: "Регистрация",
    ROW: "Ряд",
    SECTION_N: "{{SECTION}} {{N}}",
    SPOT: "Место",
    STEP_N: "Ступень {{N}}",
    TANKER: "Танкер",
    TIME: "Время",
    TIME_STAMP: "Временная метка",
    TOTAL_RECORDS_N: "Всего записей: {{N}}",
    TO_DATE_TIME_TZ: "До: {{DATE_TIME_TZ}}",
    UNIT_1: "Элемент 1",
    UNIT_HISTORY: "История элемента",
    UNIT_ID: "Идентификатор элемента",
    UNIT_TYPE: "Тип элемента",
    YARD_CHECK: "Проверка участка",
    YARD_INVENTORY: "Инвентаризация участка",
    ZOOMABLE_TYPE: "Масштабируемый {{TYPE}}",
  },
  MONTH: {
    "1": "Январь",
    "2": "Февраль",
    "3": "Март",
    "4": "Апрель",
    "5": "Май",
    "6": "Июнь",
    "7": "Июль",
    "8": "Август",
    "9": "Сентябрь",
    "10": "Октябрь",
    "11": "Ноябрь",
    "12": "Декабрь",
  },
  NAVBAR: {
    COMMAND: {
      PREVIOUS: "Назад",
    },
    DRIVER_REGISTRATION: "Регистрация водителя",
    LOGO: "Логотип",
  },
  PASSCODE_PAGE: {
    COMMAND: {
      VERIFY: "Проверка",
    },
    ENTER_PASSCODE: "Ввести пароль",
    ERROR: {
      INVALID_PASSCODE: "Недействительный пароль",
    },
  },
  PLACEHOLDER: {
    ACTUAL_TEMPERATURE_F: "Фактическая температура (°F)",
    BOL_OR_PO_NUMBERS: "Коносамент(ы)/заказ(ы)",
    BOOKING_NUMBER: "Номер бронирования",
    CARRIER: "Перевозчик",
    CARRIER_NAME_PARENT_SCAC: "Наименование перевозчика (родительский код SCAC)",
    CARRIER_SCAC: "Введите SCAC перевозчика",
    COMPANY_NAME: "Название компании",
    CURRENT_TEMPERATURE_F: "Текущая температура (°F)",
    CVIP_DATE: "Дата CVIP",
    DRIVER_FIRST_NAME: "Имя водителя",
    DRIVER_LAST_NAME: "Фамилия водителя",
    DRIVER_NAME: "Имя водителя",
    DRIVER_TYPE: "Тип водителя",
    DUNNAGE: "Деннаж",
    EMAIL: "Электронная почта",
    EMAIL_ADDRESS: "Адрес электронной почты",
    ENTRY_TYPE_REASON: "Тип въезда (причина визита)",
    EQUIPMENT_LENGTH: "Длина оборудования",
    EQUIPMENT_LOADED_STATUS: "Состояние загруженности оборудования",
    EQUIPMENT_TYPE: "Тип оборудования",
    FIRST_NAME: "Имя",
    FUEL_LEVEL: "Уровень топлива",
    ID_VALIDATION: "Проверка удостоверения",
    I_AGREE: "Соглашаюсь",
    LAST_NAME: "Фамилия",
    LOAD_ID: "Идентификатор груза",
    LOAD_ID_NUMBER: "Идентификационный номер груза",
    OUTBOUND_BOL: "Исходящий коносамент",
    PHONE_NUMBER: "Номер телефона",
    PO_NUMBER: "Номер заказа",
    PO_NUMBER_OR_LOAD_ID: "Номер заказа, ASN или идентификатор груза / справочный номер",
    PPE_DOCK_SAFETY: "СИЗ и безопасность в доке",
    PPE_DOCK_SAFETY_ASSISTANCE:
      "Если вам нужна помощь для обеспечения безопасности в доке или у вас есть вопросы о СИЗ, обратитесь к персоналу на контрольно-пропускном пункте. \n\nСпасибо",
    PPE_DOCK_SAFETY_COMPLIANCE:
      "Выбирая «ДА», вы соглашаетесь следовать всем применимым законам и нашим правилам. Запрещено несанкционированное использование, изменение или распространение. Мы не несем ответственности за какой-либо ущерб. Чтобы получить дополнительную информацию, ознакомьтесь с нашей политикой конфиденциальности и полным текстом условий.\n\nНесоблюдение требований к безопасности в доках или использованию СИЗ может привести к штрафам. Если вам нужна помощь для обеспечения безопасности в доке или у вас есть вопросы о СИЗ, обратитесь к персоналу на контрольно-пропускном пункте.",
    REASON_FOR_ENTRY: "Причина въезда",
    REEFER_FUEL_LEVEL: "Уровень топлива в рефрижераторе",
    REEFER_ON: "Рефрижератор вкл./выкл.",
    SEAL_NUMBER: "Номер пломбы",
    SEARCH_CARRIER: "Искать перевозчика…",
    SELECT_FACILITY: "Выбрать объект…",
    SELECT_X: "Выбрать {{X}}",
    SIGNATURE: "Подпись",
    TEMPERATURE_F: "Температура (°F)",
    TRACTOR_CARRIER_NAME: "Наименование перевозчика тягача",
    TRACTOR_NUMBER: "Номер тягача",
    TRAILER_CARRIER_NAME: "Наименование перевозчика прицепа",
    TRAILER_MIDDLE: "Средний",
    TRAILER_NOSE: "Передний",
    TRAILER_NUMBER: "Номер прицепа",
    TRAILER_TAIL: "Задний",
    TRAILER_TYPE: "Тип прицепа",
    VALIDATION_PERIOD: "Период проверки",
  },
  QUESTION: {
    ACTUAL_TEMPERATURE_F: "Фактическая температура в °F",
    APPOINTMENT_DETAILS: "Сведения о назначении",
    COMPANY_INFO: "Информация о компании",
    CONFIRM_SEAL_AND_TRAILER_NUMBER: "Проверьте целостность пломбы и номер прицепа",
    CONFIRM_TRAILER_CONDITION:
      "Убедитесь, что в прицепе нет мусора, тандемы сдвинуты назад, а рефрижератор работает.",
    DRIVER_NAME: "Введите имя водителя",
    DRIVER_TYPE: "Тип водителя",
    ENTRY_PURPOSE: "Выберите цель въезда",
    ENTRY_TYPE: "Выберите тип въезда",
    EQUIPMENT_DETAILS: "Сведения об оборудовании",
    GENERIC: "Заполните информацию",
    LOAD_DETAILS: "Сведения о грузе",
    LOAD_TYPE: "Выберите тип груза",
    PERSONAL_INFO: "Личная информация",
    PPE_DOCK_SAFETY: "СИЗ и безопасность в доке",
    SET_TEMPERATURE_F: "Установленная температура в °F",
    SHIPPING_DETAILS: "Сведения об отправке",
    VEHICLE_DETAILS: "Сведения об автомобиле",
    VISIT_TYPE: "Выберите тип визита",
    WAIVER: "Отказ",
  },
  STATUS: {
    ACTIVE: "Активный",
    EXPIRED: "Срок действия истек",
    EXPIRING_SOON: "Срок действия скоро истекает",
  },
  SUCCESS_PAGE: {
    COMMAND: {
      DOWNLOAD: "Загрузить",
      EMAIL: "Электронная почта",
      HOME: "Главная",
      MESSAGE: "Сообщение",
      START_OVER: "Начать сначала",
    },
    DRIVER_CHECK_IN_SUCCESS: "Регистрация въезда начата",
    DRIVER_CHECK_OUT_SUCCESS: "Регистрация отъезда начата",
    GENERATING_QR_CODE: "QR-код генерируется.",
    PLEASE_CHECK_DASHBOARD: "Проверьте статус на приборной панели AVAC",
    PLEASE_SCAN_CODE: "Отсканируйте QR-код на стойке.",
    PLEASE_WAIT: "Пожалуйста, подождите…",
    QR_CODE_GENERATED: "QR-код сгенерирован.",
  },
  SUGGESTION: {
    PO_NUMBER_OR_LOAD_ID: "Заполните поле «Номер заказа» или «Идентификатор груза»",
  },
  TITLE: {
    CARRIER: "Перевозчик",
    CATEGORY: "Категория",
    COMPANY_NAME: "Название компании",
    EMAIL_ADDRESS: "Адрес электронной почты",
    ENTRY_SUB_TYPE: "Подтип въезда",
    ENTRY_TYPE: "Тип въезда",
    FIRST_NAME: "Имя",
    LAST_NAME: "Фамилия",
    PHONE_NUMBER: "Номер телефона",
    REASON_FOR_ENTRY: "Причина въезда",
    REFERENCE_NUMBER: "Справочный номер",
    SEAL_NUMBER: "Номер пломбы",
    SIGNATURE: "Подпись",
    TEMPERATURE: "Температура",
    TRAILER_NUMBER: "Номер прицепа",
    VALIDATION_PERIOD: "Период проверки",
  },
  TOOLTIP: {
    ADD: "Добавить",
    ARROW: "стрелка",
    COMPANY_LOGO: "Логотип компании",
    DOWNLOAD: "загрузить",
    LOGO: "Логотип",
    MENU: "меню",
    SORT_ASC: "сортировка по возрастанию",
    SORT_DESC: "сортировка по убыванию",
  },
  VALIDATION: {
    EMAIL_ADDRESS: "Введите действительный адрес электронной почты",
    ERROR: {
      BOL_VALIDATION_FAILED: "Не удалось подтвердить справочный номер.",
      FUEL_VALIDATION_FAILED: "Не удалось получить статистику рефрижератора",
      INVALID_BOOKING_NUMBER: "Недействительный номер бронирования",
      INVALID_FACILITY: "Недействительный объект",
      INVALID_LOAD_ID: "Недействительный идентификатор груза",
      LOAD_ID_VALIDATION_FAILED: "Не удалось подтвердить идентификационный номер груза",
      PO_VALIDATION_FAILED:
        "Недействительный заказ. Повторите попытку или обратитесь к приемщику грузов.",
      TRAILER_VALIDATION_FAILED: "Не удалось подтвердить сведения прицепа",
    },
    FLOAT: "Вводите правильные номера (например, 123 или 123.45)",
    NUMERIC: "Вводите только цифры",
    PERSON_NAME: "Поддерживаются только буквы и пробелы",
    PHONE_NUMBER: "Неправильный формат телефонного номера",
    PO_NUMBER_OR_LOAD_ID: "Укажите номер заказа или идентификатор груза",
    TEMPERATURE_FROM_N20F_TO_P100F:
      "Температура должна быть в диапазоне от –20 до 100 °F",
    VALIDATING_REFERENCE_NUMBER: "Проверка справочного номера",
    VALIDATING_TRAILER_DETAILS: "Проверка сведений о прицепе",
  },
} as const;
